import { List, Record } from "immutable";

import { AccessReviewReportModel } from "./AccessReviewReportModel";
import { AccessReviewSubordinatePermissionModel } from "./AccessReviewSubordinatePermissionModel";

interface IAccessReviewSubordinateStatistics {
  permissionsStatus: {
    approved: number;
    denied: number;
    flagged: number;
    pending: number;
  };
}

const defaults = {
  accessReviewReport: null as AccessReviewReportModel | null,
  accessReviewReportId: "",
  accessReviewSubordinatePermissions: null as List<AccessReviewSubordinatePermissionModel> | null,
  id: "",
  permissionsCount: null as null | number,
  statistics: null as IAccessReviewSubordinateStatistics | null,
  userId: "",
};

export type TAccessReviewSubordinateModel = typeof defaults;

export class AccessReviewSubordinateModel extends Record<TAccessReviewSubordinateModel>(defaults) {
  public get notPendingPermissionsSize(): number {
    if (this.statistics) {
      return this.permissionsSize - (this.statistics.permissionsStatus.pending || 0);
    }
    if (this.accessReviewSubordinatePermissions) {
      return this.accessReviewSubordinatePermissions.filter((permission) => permission.status !== "pending").size;
    }
    return 0;
  }

  public get permissionsSize(): number {
    return this.permissionsCount || this.accessReviewSubordinatePermissions?.size || 0;
  }

  public get status(): "done" | "inProgress" | "pending" {
    if (this.notPendingPermissionsSize > 0) {
      return this.notPendingPermissionsSize === this.permissionsSize ? "done" : "inProgress";
    }
    return "pending";
  }

  static fromServerData(data: unknown): AccessReviewSubordinateModel {
    const {
      accessReviewReport,
      accessReviewReportId,
      accessReviewSubordinatePermissions,
      id,
      permissionsCount,
      statistics,
      userId,
    } = data as TAccessReviewSubordinateModel;
    return new AccessReviewSubordinateModel({
      accessReviewReport: accessReviewReport ? AccessReviewReportModel.fromServerData(accessReviewReport) : null,
      accessReviewReportId,
      accessReviewSubordinatePermissions: accessReviewSubordinatePermissions
        ? List(accessReviewSubordinatePermissions.map(AccessReviewSubordinatePermissionModel.fromServerData))
        : null,
      id,
      permissionsCount,
      statistics,
      userId,
    });
  }
}
